import { api } from './emptyApi'

export const addTagTypes = [
  'Tickets',
  'Projects',
  'Tasks',
  'Comments',
  'Task Activity Events',
  'Work Orders',
  'Task Templates',
  'Project Templates',
  'Assets',
  'Project assets',
  'Attachments',
  'Documents',
  'Plans',
  'Email Intake',
  'Agent Sessions'
] as const
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getPrefix: build.query<GetPrefixResponse, GetPrefixArgs>({
        query: (queryArg) => ({
          url: `/api/v1/ticket-prefixes`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['Tickets']
      }),
      updatePrefix: build.mutation<UpdatePrefixResponse, UpdatePrefixArgs>({
        query: (queryArg) => ({
          url: `/api/v1/ticket-prefixes`,
          method: 'PUT',
          body: queryArg.ticketPrefixUpdateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Tickets']
      }),
      assignPrefix: build.mutation<AssignPrefixResponse, AssignPrefixArgs>({
        query: (queryArg) => ({
          url: `/api/v1/ticket-prefixes`,
          method: 'POST',
          body: queryArg.ticketPrefixAssignParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Tickets']
      }),
      createTicket: build.mutation<CreateTicketResponse, CreateTicketArgs>({
        query: (queryArg) => ({
          url: `/api/v1/tickets`,
          method: 'POST',
          body: queryArg.taskCreateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Tickets']
      }),
      listTickets: build.query<ListTicketsResponse, ListTicketsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/tickets`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          },
          params: {
            planId: queryArg.planId,
            limit: queryArg.limit,
            starting_after: queryArg.startingAfter
          }
        }),
        providesTags: ['Tickets']
      }),
      getTicket: build.query<GetTicketResponse, GetTicketArgs>({
        query: (queryArg) => ({
          url: `/api/v1/tickets/${queryArg.ticketId}`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['Tickets']
      }),
      updateTicket: build.mutation<UpdateTicketResponse, UpdateTicketArgs>({
        query: (queryArg) => ({
          url: `/api/v1/tickets/${queryArg.ticketId}`,
          method: 'PUT',
          body: queryArg.taskUpdateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Tickets']
      }),
      deleteTicket: build.mutation<DeleteTicketResponse, DeleteTicketArgs>({
        query: (queryArg) => ({
          url: `/api/v1/tickets/${queryArg.ticketId}`,
          method: 'DELETE',
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Tickets']
      }),
      createProject: build.mutation<CreateProjectResponse, CreateProjectArgs>({
        query: (queryArg) => ({
          url: `/api/v1/projects`,
          method: 'POST',
          body: queryArg.projectCreateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Projects']
      }),
      listProjects: build.query<ListProjectsResponse, ListProjectsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/projects`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          },
          params: {
            limit: queryArg.limit,
            starting_after: queryArg.startingAfter
          }
        }),
        providesTags: ['Projects']
      }),
      getProject: build.query<GetProjectResponse, GetProjectArgs>({
        query: (queryArg) => ({
          url: `/api/v1/projects/${queryArg.projectId}`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['Projects']
      }),
      updateProject: build.mutation<UpdateProjectResponse, UpdateProjectArgs>({
        query: (queryArg) => ({
          url: `/api/v1/projects/${queryArg.projectId}`,
          method: 'PUT',
          body: queryArg.projectUpdateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Projects']
      }),
      deleteProject: build.mutation<DeleteProjectResponse, DeleteProjectArgs>({
        query: (queryArg) => ({
          url: `/api/v1/projects/${queryArg.projectId}`,
          method: 'DELETE',
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Projects']
      }),
      getProjectUpdates: build.query<GetProjectUpdatesResponse, GetProjectUpdatesArgs>({
        query: (queryArg) => ({
          url: `/api/v1/projects/${queryArg.projectId}/updates`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['Projects']
      }),
      createProjectUpdate: build.mutation<CreateProjectUpdateResponse, CreateProjectUpdateArgs>({
        query: (queryArg) => ({
          url: `/api/v1/projects/${queryArg.projectId}/updates`,
          method: 'POST',
          body: queryArg.projectUpdateCreateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Projects']
      }),
      createTask: build.mutation<CreateTaskResponse, CreateTaskArgs>({
        query: (queryArg) => ({
          url: `/api/v1/projects/${queryArg.projectId}/tasks`,
          method: 'POST',
          body: queryArg.taskCreateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Tasks']
      }),
      listTasks: build.query<ListTasksResponse, ListTasksArgs>({
        query: (queryArg) => ({
          url: `/api/v1/projects/${queryArg.projectId}/tasks`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          },
          params: {
            limit: queryArg.limit,
            starting_after: queryArg.startingAfter
          }
        }),
        providesTags: ['Tasks']
      }),
      getTask: build.query<GetTaskResponse, GetTaskArgs>({
        query: (queryArg) => ({
          url: `/api/v1/projects/${queryArg.projectId}/tasks/${queryArg.taskId}`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['Tasks']
      }),
      updateTask: build.mutation<UpdateTaskResponse, UpdateTaskArgs>({
        query: (queryArg) => ({
          url: `/api/v1/projects/${queryArg.projectId}/tasks/${queryArg.taskId}`,
          method: 'PUT',
          body: queryArg.taskUpdateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Tasks']
      }),
      deleteTask: build.mutation<DeleteTaskResponse, DeleteTaskArgs>({
        query: (queryArg) => ({
          url: `/api/v1/projects/${queryArg.projectId}/tasks/${queryArg.taskId}`,
          method: 'DELETE',
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Tasks']
      }),
      getSubtasks: build.query<GetSubtasksResponse, GetSubtasksArgs>({
        query: (queryArg) => ({
          url: `/api/v1/projects/${queryArg.projectId}/tasks/${queryArg.taskId}/subtasks`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['Tasks']
      }),
      updateTaskStatus: build.mutation<UpdateTaskStatusResponse, UpdateTaskStatusArgs>({
        query: (queryArg) => ({
          url: `/api/v1/projects/${queryArg.projectId}/tasks/${queryArg.taskId}/status`,
          method: 'PATCH',
          body: queryArg.taskStatus,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Tasks']
      }),
      updateChecklist: build.mutation<UpdateChecklistResponse, UpdateChecklistArgs>({
        query: (queryArg) => ({
          url: `/api/v1/projects/${queryArg.projectId}/tasks/${queryArg.taskId}/checklist`,
          method: 'PUT',
          body: queryArg.checklist,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Tasks']
      }),
      createComment: build.mutation<CreateCommentResponse, CreateCommentArgs>({
        query: (queryArg) => ({
          url: `/api/v1/projects/${queryArg.projectId}/tasks/${queryArg.taskId}/comments`,
          method: 'POST',
          body: queryArg.commentCreateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Comments']
      }),
      listComments: build.query<ListCommentsResponse, ListCommentsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/projects/${queryArg.projectId}/tasks/${queryArg.taskId}/comments`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          },
          params: {
            limit: queryArg.limit,
            starting_after: queryArg.startingAfter
          }
        }),
        providesTags: ['Comments']
      }),
      getComment: build.query<GetCommentResponse, GetCommentArgs>({
        query: (queryArg) => ({
          url: `/api/v1/projects/${queryArg.projectId}/tasks/${queryArg.taskId}/comments/${queryArg.commentId}`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['Comments']
      }),
      updateComment: build.mutation<UpdateCommentResponse, UpdateCommentArgs>({
        query: (queryArg) => ({
          url: `/api/v1/projects/${queryArg.projectId}/tasks/${queryArg.taskId}/comments/${queryArg.commentId}`,
          method: 'PUT',
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Comments']
      }),
      deleteComment: build.mutation<DeleteCommentResponse, DeleteCommentArgs>({
        query: (queryArg) => ({
          url: `/api/v1/projects/${queryArg.projectId}/tasks/${queryArg.taskId}/comments/${queryArg.commentId}`,
          method: 'DELETE',
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Comments']
      }),
      listActivityEvents: build.query<ListActivityEventsResponse, ListActivityEventsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/projects/${queryArg.projectId}/tasks/${queryArg.taskId}/activity-events`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          },
          params: {
            limit: queryArg.limit,
            starting_after: queryArg.startingAfter
          }
        }),
        providesTags: ['Task Activity Events']
      }),
      createWorkOrder: build.mutation<CreateWorkOrderResponse, CreateWorkOrderArgs>({
        query: (queryArg) => ({
          url: `/api/v1/projects/${queryArg.projectId}/tasks/${queryArg.taskId}/work-orders`,
          method: 'POST',
          body: queryArg.workOrderCreateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Work Orders']
      }),
      listWorkOrders: build.query<ListWorkOrdersResponse, ListWorkOrdersArgs>({
        query: (queryArg) => ({
          url: `/api/v1/projects/${queryArg.projectId}/tasks/${queryArg.taskId}/work-orders`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          },
          params: {
            limit: queryArg.limit,
            starting_after: queryArg.startingAfter
          }
        }),
        providesTags: ['Work Orders']
      }),
      getWorkOrder: build.query<GetWorkOrderResponse, GetWorkOrderArgs>({
        query: (queryArg) => ({
          url: `/api/v1/projects/${queryArg.projectId}/tasks/${queryArg.taskId}/work-orders/${queryArg.workOrderId}`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['Work Orders']
      }),
      cancelWorkOrder: build.mutation<CancelWorkOrderResponse, CancelWorkOrderArgs>({
        query: (queryArg) => ({
          url: `/api/v1/projects/${queryArg.projectId}/tasks/${queryArg.taskId}/work-orders/${queryArg.workOrderId}/cancel`,
          method: 'POST',
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Work Orders']
      }),
      approveWorkOrder: build.mutation<ApproveWorkOrderResponse, ApproveWorkOrderArgs>({
        query: (queryArg) => ({
          url: `/api/v1/projects/${queryArg.projectId}/tasks/${queryArg.taskId}/work-orders/${queryArg.workOrderId}/approve`,
          method: 'POST',
          body: queryArg.workOrderApproveParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Work Orders']
      }),
      rejectWorkOrder: build.mutation<RejectWorkOrderResponse, RejectWorkOrderArgs>({
        query: (queryArg) => ({
          url: `/api/v1/projects/${queryArg.projectId}/tasks/${queryArg.taskId}/work-orders/${queryArg.workOrderId}/reject`,
          method: 'POST',
          body: queryArg.workOrderRejectParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Work Orders']
      }),
      createTaskTemplate: build.mutation<CreateTaskTemplateResponse, CreateTaskTemplateArgs>({
        query: (queryArg) => ({
          url: `/api/v1/task-templates`,
          method: 'POST',
          body: queryArg.taskTemplateCreateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Task Templates']
      }),
      listTaskTemplates: build.query<ListTaskTemplatesResponse, ListTaskTemplatesArgs>({
        query: (queryArg) => ({
          url: `/api/v1/task-templates`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          },
          params: {
            category: queryArg.category
          }
        }),
        providesTags: ['Task Templates']
      }),
      applyTemplateToProject: build.mutation<ApplyTemplateToProjectResponse, ApplyTemplateToProjectArgs>({
        query: (queryArg) => ({
          url: `/api/v1/task-templates/projects/${queryArg.projectId}/apply-to-project`,
          method: 'POST',
          body: queryArg.taskTemplateApplyParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Task Templates']
      }),
      applyTemplateToAssets: build.mutation<ApplyTemplateToAssetsResponse, ApplyTemplateToAssetsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/task-templates/batch-apply`,
          method: 'POST',
          body: queryArg.taskTemplateApplyParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          },
          params: {
            projectId: queryArg.projectId,
            assetIds: queryArg.assetIds
          }
        }),
        invalidatesTags: ['Task Templates']
      }),
      getTasksGroupedByTemplate: build.query<GetTasksGroupedByTemplateResponse, GetTasksGroupedByTemplateArgs>({
        query: (queryArg) => ({
          url: `/api/v1/task-templates/projects/${queryArg.projectId}/grouped-by-template`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['Task Templates']
      }),
      getTaskTemplate: build.query<GetTaskTemplateResponse, GetTaskTemplateArgs>({
        query: (queryArg) => ({
          url: `/api/v1/task-templates/${queryArg.templateId}`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['Task Templates']
      }),
      updateTaskTemplate: build.mutation<UpdateTaskTemplateResponse, UpdateTaskTemplateArgs>({
        query: (queryArg) => ({
          url: `/api/v1/task-templates/${queryArg.templateId}`,
          method: 'PUT',
          body: queryArg.taskTemplateCreateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Task Templates']
      }),
      deleteTaskTemplate: build.mutation<DeleteTaskTemplateResponse, DeleteTaskTemplateArgs>({
        query: (queryArg) => ({
          url: `/api/v1/task-templates/${queryArg.templateId}`,
          method: 'DELETE',
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Task Templates']
      }),
      createProjectTemplate: build.mutation<CreateProjectTemplateResponse, CreateProjectTemplateArgs>({
        query: (queryArg) => ({
          url: `/api/v1/project-templates`,
          method: 'POST',
          body: queryArg.projectTemplateCreateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Project Templates']
      }),
      listProjectTemplates: build.query<ListProjectTemplatesResponse, ListProjectTemplatesArgs>({
        query: (queryArg) => ({
          url: `/api/v1/project-templates`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          },
          params: {
            category: queryArg.category
          }
        }),
        providesTags: ['Project Templates']
      }),
      getProjectTemplate: build.query<GetProjectTemplateResponse, GetProjectTemplateArgs>({
        query: (queryArg) => ({
          url: `/api/v1/project-templates/${queryArg.templateId}`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['Project Templates']
      }),
      updateProjectTemplate: build.mutation<UpdateProjectTemplateResponse, UpdateProjectTemplateArgs>({
        query: (queryArg) => ({
          url: `/api/v1/project-templates/${queryArg.templateId}`,
          method: 'PUT',
          body: queryArg.projectTemplateCreateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Project Templates']
      }),
      deleteProjectTemplate: build.mutation<DeleteProjectTemplateResponse, DeleteProjectTemplateArgs>({
        query: (queryArg) => ({
          url: `/api/v1/project-templates/${queryArg.templateId}`,
          method: 'DELETE',
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Project Templates']
      }),
      applyProjectTemplate: build.mutation<ApplyProjectTemplateResponse, ApplyProjectTemplateArgs>({
        query: (queryArg) => ({
          url: `/api/v1/project-templates/${queryArg.templateId}/apply`,
          method: 'POST',
          body: queryArg.projectTemplateApplyParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Project Templates']
      }),
      createAsset: build.mutation<CreateAssetResponse, CreateAssetArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assets`,
          method: 'POST',
          body: queryArg.assetCreateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Assets']
      }),
      listAssets: build.query<ListAssetsResponse, ListAssetsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assets`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          },
          params: {
            siteId: queryArg.siteId,
            projectId: queryArg.projectId,
            organizationId: queryArg.organizationId,
            limit: queryArg.limit,
            starting_after: queryArg.startingAfter
          }
        }),
        providesTags: ['Assets']
      }),
      bulkUpdateAssets: build.mutation<BulkUpdateAssetsResponse, BulkUpdateAssetsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assets`,
          method: 'PATCH',
          body: queryArg.assetBulkUpdateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Assets']
      }),
      reconcileAssets: build.mutation<ReconcileAssetsResponse, ReconcileAssetsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assets`,
          method: 'PUT',
          body: queryArg.assetReconcileParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          },
          params: {
            siteId: queryArg.siteId
          }
        }),
        invalidatesTags: ['Assets']
      }),
      deleteAsset: build.mutation<DeleteAssetResponse, DeleteAssetArgs>({
        query: (queryArg) => ({
          url: `/api/v1/assets/${queryArg.assetId}`,
          method: 'DELETE',
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Assets']
      }),
      listGroupedByAsset: build.query<ListGroupedByAssetResponse, ListGroupedByAssetArgs>({
        query: (queryArg) => ({
          url: `/api/v1/projects/${queryArg.projectId}/assets/grouped`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['Project assets']
      }),
      searchWithinBounds: build.query<SearchWithinBoundsResponse, SearchWithinBoundsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/projects/${queryArg.projectId}/assets/search`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          },
          params: {
            minLat: queryArg.minLat,
            maxLat: queryArg.maxLat,
            minLng: queryArg.minLng,
            maxLng: queryArg.maxLng
          }
        }),
        providesTags: ['Project assets']
      }),
      listArAssets: build.query<ListArAssetsResponse, ListArAssetsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/projects/${queryArg.projectId}/assets/ar`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['Project assets']
      }),
      syncFromMarker: build.mutation<SyncFromMarkerResponse, SyncFromMarkerArgs>({
        query: (queryArg) => ({
          url: `/api/v1/projects/${queryArg.projectId}/assets/sync`,
          method: 'POST',
          body: queryArg.assetCreateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Project assets']
      }),
      retrieveByMarkerId: build.query<RetrieveByMarkerIdResponse, RetrieveByMarkerIdArgs>({
        query: (queryArg) => ({
          url: `/api/v1/projects/${queryArg.projectId}/assets/markers/${queryArg.arMarkerId}`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['Project assets']
      }),
      listProjectAssets: build.query<ListProjectAssetsResponse, ListProjectAssetsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/projects/${queryArg.projectId}/assets`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          },
          params: {
            limit: queryArg.limit,
            starting_after: queryArg.startingAfter
          }
        }),
        providesTags: ['Project assets']
      }),
      linkAssetToProject: build.mutation<LinkAssetToProjectResponse, LinkAssetToProjectArgs>({
        query: (queryArg) => ({
          url: `/api/v1/projects/${queryArg.projectId}/assets/${queryArg.assetId}`,
          method: 'PUT',
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Project assets']
      }),
      retrieveAsset: build.query<RetrieveAssetResponse, RetrieveAssetArgs>({
        query: (queryArg) => ({
          url: `/api/v1/projects/${queryArg.projectId}/assets/${queryArg.assetId}`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['Project assets']
      }),
      updateAsset: build.mutation<UpdateAssetResponse, UpdateAssetArgs>({
        query: (queryArg) => ({
          url: `/api/v1/projects/${queryArg.projectId}/assets/${queryArg.assetId}`,
          method: 'POST',
          body: queryArg.assetUpdateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Project assets']
      }),
      unlinkAssetFromProject: build.mutation<UnlinkAssetFromProjectResponse, UnlinkAssetFromProjectArgs>({
        query: (queryArg) => ({
          url: `/api/v1/projects/${queryArg.projectId}/assets/${queryArg.assetId}`,
          method: 'DELETE',
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Project assets']
      }),
      listAssetTasks: build.query<ListAssetTasksResponse, ListAssetTasksArgs>({
        query: (queryArg) => ({
          url: `/api/v1/projects/${queryArg.projectId}/assets/${queryArg.assetId}/tasks`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['Project assets']
      }),
      applyTemplateToAsset: build.mutation<ApplyTemplateToAssetResponse, ApplyTemplateToAssetArgs>({
        query: (queryArg) => ({
          url: `/api/v1/projects/${queryArg.projectId}/assets/${queryArg.assetId}/tasks`,
          method: 'POST',
          body: queryArg.taskTemplateApplyParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Project assets']
      }),
      createAttachmentUploadUrl: build.mutation<CreateAttachmentUploadUrlResponse, CreateAttachmentUploadUrlArgs>({
        query: (queryArg) => ({
          url: `/api/v1/entities/${queryArg.entityId}/attachments/upload-url`,
          method: 'POST',
          body: queryArg.attachmentCreateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Attachments']
      }),
      getAttachmentDownloadUrl: build.query<GetAttachmentDownloadUrlResponse, GetAttachmentDownloadUrlArgs>({
        query: (queryArg) => ({
          url: `/api/v1/entities/${queryArg.entityId}/attachments/${queryArg.attachmentId}/download-url`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['Attachments']
      }),
      getAttachment: build.query<GetAttachmentResponse, GetAttachmentArgs>({
        query: (queryArg) => ({
          url: `/api/v1/entities/${queryArg.entityId}/attachments/${queryArg.attachmentId}`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['Attachments']
      }),
      deleteAttachment: build.mutation<DeleteAttachmentResponse, DeleteAttachmentArgs>({
        query: (queryArg) => ({
          url: `/api/v1/entities/${queryArg.entityId}/attachments/${queryArg.attachmentId}`,
          method: 'DELETE',
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Attachments']
      }),
      listAttachments: build.query<ListAttachmentsResponse, ListAttachmentsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/entities/${queryArg.entityId}/attachments`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['Attachments']
      }),
      createDocument: build.mutation<CreateDocumentResponse, CreateDocumentArgs>({
        query: (queryArg) => ({
          url: `/api/v1/documents`,
          method: 'POST',
          body: queryArg.documentCreateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Documents']
      }),
      listDocuments: build.query<ListDocumentsResponse, ListDocumentsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/documents`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          },
          params: {
            limit: queryArg.limit,
            starting_after: queryArg.startingAfter
          }
        }),
        providesTags: ['Documents']
      }),
      getDocument: build.query<GetDocumentResponse, GetDocumentArgs>({
        query: (queryArg) => ({
          url: `/api/v1/documents/${queryArg.documentId}`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['Documents']
      }),
      updateDocument: build.mutation<UpdateDocumentResponse, UpdateDocumentArgs>({
        query: (queryArg) => ({
          url: `/api/v1/documents/${queryArg.documentId}`,
          method: 'PUT',
          body: queryArg.documentUpdateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Documents']
      }),
      deleteDocument: build.mutation<DeleteDocumentResponse, DeleteDocumentArgs>({
        query: (queryArg) => ({
          url: `/api/v1/documents/${queryArg.documentId}`,
          method: 'DELETE',
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Documents']
      }),
      createDocumentUploadUrl: build.mutation<CreateDocumentUploadUrlResponse, CreateDocumentUploadUrlArgs>({
        query: (queryArg) => ({
          url: `/api/v1/documents/${queryArg.documentId}/upload-url`,
          method: 'POST',
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Documents']
      }),
      getDocumentDownloadUrl: build.query<GetDocumentDownloadUrlResponse, GetDocumentDownloadUrlArgs>({
        query: (queryArg) => ({
          url: `/api/v1/documents/${queryArg.documentId}/download-url`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['Documents']
      }),
      createPlan: build.mutation<CreatePlanResponse, CreatePlanArgs>({
        query: (queryArg) => ({
          url: `/api/v1/plans`,
          method: 'POST',
          body: queryArg.planCreateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Plans']
      }),
      listPlans: build.query<ListPlansResponse, ListPlansArgs>({
        query: (queryArg) => ({
          url: `/api/v1/plans`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          },
          params: {
            status: queryArg.status,
            limit: queryArg.limit,
            starting_after: queryArg.startingAfter
          }
        }),
        providesTags: ['Plans']
      }),
      previewPlan: build.mutation<PreviewPlanResponse, PreviewPlanArgs>({
        query: (queryArg) => ({
          url: `/api/v1/plans/preview`,
          method: 'POST',
          body: queryArg.planPreviewParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Plans']
      }),
      getPlan: build.query<GetPlanResponse, GetPlanArgs>({
        query: (queryArg) => ({
          url: `/api/v1/plans/${queryArg.planId}`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['Plans']
      }),
      updatePlan: build.mutation<UpdatePlanResponse, UpdatePlanArgs>({
        query: (queryArg) => ({
          url: `/api/v1/plans/${queryArg.planId}`,
          method: 'PUT',
          body: queryArg.planUpdateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Plans']
      }),
      pausePlan: build.mutation<PausePlanResponse, PausePlanArgs>({
        query: (queryArg) => ({
          url: `/api/v1/plans/${queryArg.planId}/pause`,
          method: 'POST',
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Plans']
      }),
      resumePlan: build.mutation<ResumePlanResponse, ResumePlanArgs>({
        query: (queryArg) => ({
          url: `/api/v1/plans/${queryArg.planId}/resume`,
          method: 'POST',
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Plans']
      }),
      archivePlan: build.mutation<ArchivePlanResponse, ArchivePlanArgs>({
        query: (queryArg) => ({
          url: `/api/v1/plans/${queryArg.planId}/archive`,
          method: 'POST',
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Plans']
      }),
      getCycles: build.query<GetCyclesResponse, GetCyclesArgs>({
        query: (queryArg) => ({
          url: `/api/v1/plans/${queryArg.planId}/cycles`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          },
          params: {
            past_limit: queryArg.pastLimit,
            upcoming_limit: queryArg.upcomingLimit
          }
        }),
        providesTags: ['Plans']
      }),
      getChargerPlans: build.query<GetChargerPlansResponse, GetChargerPlansArgs>({
        query: (queryArg) => ({
          url: `/api/v1/chargers/${queryArg.chargerId}/plans`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['Plans']
      }),
      listAddresses: build.query<ListAddressesResponse, ListAddressesArgs>({
        query: (queryArg) => ({
          url: `/api/v1/email-intake-addresses`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['Email Intake']
      }),
      createAddress: build.mutation<CreateAddressResponse, CreateAddressArgs>({
        query: (queryArg) => ({
          url: `/api/v1/email-intake-addresses`,
          method: 'POST',
          body: queryArg.emailIntakeAddressCreateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Email Intake']
      }),
      getAddress: build.query<GetAddressResponse, GetAddressArgs>({
        query: (queryArg) => ({
          url: `/api/v1/email-intake-addresses/${queryArg.alias}`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['Email Intake']
      }),
      updateAddress: build.mutation<UpdateAddressResponse, UpdateAddressArgs>({
        query: (queryArg) => ({
          url: `/api/v1/email-intake-addresses/${queryArg.alias}`,
          method: 'PUT',
          body: queryArg.emailIntakeAddressUpdateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Email Intake']
      }),
      deleteAddress: build.mutation<DeleteAddressResponse, DeleteAddressArgs>({
        query: (queryArg) => ({
          url: `/api/v1/email-intake-addresses/${queryArg.alias}`,
          method: 'DELETE',
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Email Intake']
      }),
      listTicketAgentSessions: build.query<ListTicketAgentSessionsResponse, ListTicketAgentSessionsArgs>({
        query: (queryArg) => ({
          url: `/api/v1/tickets/${queryArg.ticketId}/agent-sessions`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['Agent Sessions']
      }),
      createTicketAgentSession: build.mutation<CreateTicketAgentSessionResponse, CreateTicketAgentSessionArgs>({
        query: (queryArg) => ({
          url: `/api/v1/tickets/${queryArg.ticketId}/agent-sessions`,
          method: 'POST',
          body: queryArg.agentSessionCreateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Agent Sessions']
      }),
      getAgentSession: build.query<GetAgentSessionResponse, GetAgentSessionArgs>({
        query: (queryArg) => ({
          url: `/api/v1/agent-sessions/${queryArg.sessionId}`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        providesTags: ['Agent Sessions']
      }),
      updateAgentSession: build.mutation<UpdateAgentSessionResponse, UpdateAgentSessionArgs>({
        query: (queryArg) => ({
          url: `/api/v1/agent-sessions/${queryArg.sessionId}`,
          method: 'PATCH',
          body: queryArg.agentSessionUpdateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Agent Sessions']
      }),
      listAgentActivities: build.query<ListAgentActivitiesResponse, ListAgentActivitiesArgs>({
        query: (queryArg) => ({
          url: `/api/v1/agent-sessions/${queryArg.sessionId}/activities`,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          },
          params: {
            includeEphemeral: queryArg.includeEphemeral,
            limit: queryArg.limit,
            starting_after: queryArg.startingAfter
          }
        }),
        providesTags: ['Agent Sessions']
      }),
      createAgentActivity: build.mutation<CreateAgentActivityResponse, CreateAgentActivityArgs>({
        query: (queryArg) => ({
          url: `/api/v1/agent-sessions/${queryArg.sessionId}/activities`,
          method: 'POST',
          body: queryArg.agentActivityCreateBody,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Agent Sessions']
      }),
      createAgentPrompt: build.mutation<CreateAgentPromptResponse, CreateAgentPromptArgs>({
        query: (queryArg) => ({
          url: `/api/v1/agent-sessions/${queryArg.sessionId}/prompts`,
          method: 'POST',
          body: queryArg.agentPromptCreateParams,
          headers: {
            'X-Organization-Id': queryArg['X-Organization-Id']
          }
        }),
        invalidatesTags: ['Agent Sessions']
      })
    }),
    overrideExisting: false
  })
export { injectedRtkApi as enhancedApi }
export type GetPrefixResponse = /** status 200 Successful Response */ TicketPrefix
export type GetPrefixArgs = {
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type UpdatePrefixResponse = /** status 200 Successful Response */ TicketPrefix
export type UpdatePrefixArgs = {
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  ticketPrefixUpdateParams: TicketPrefixUpdateParams
}
export type AssignPrefixResponse = /** status 200 Successful Response */ TicketPrefix
export type AssignPrefixArgs = {
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  ticketPrefixAssignParams: TicketPrefixAssignParams
}
export type CreateTicketResponse = /** status 201 Successful Response */ Task[]
export type CreateTicketArgs = {
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  taskCreateParams: TaskCreateParams
}
export type ListTicketsResponse = /** status 200 Successful Response */ CursorPagedListTask
export type ListTicketsArgs = {
  planId?: string | null
  limit?: number
  startingAfter?: string | null
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type GetTicketResponse = /** status 200 Successful Response */ Task
export type GetTicketArgs = {
  ticketId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type UpdateTicketResponse = /** status 200 Successful Response */ Task
export type UpdateTicketArgs = {
  ticketId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  taskUpdateParams: TaskUpdateParams
}
export type DeleteTicketResponse = unknown
export type DeleteTicketArgs = {
  ticketId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type CreateProjectResponse = /** status 201 Successful Response */ Project
export type CreateProjectArgs = {
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  projectCreateParams: ProjectCreateParams
}
export type ListProjectsResponse = /** status 200 Successful Response */ CursorPagedListProject
export type ListProjectsArgs = {
  limit?: number
  startingAfter?: string | null
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type GetProjectResponse = /** status 200 Successful Response */ Project
export type GetProjectArgs = {
  projectId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type UpdateProjectResponse = /** status 200 Successful Response */ Project
export type UpdateProjectArgs = {
  projectId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  projectUpdateParams: ProjectUpdateParams
}
export type DeleteProjectResponse = unknown
export type DeleteProjectArgs = {
  projectId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type GetProjectUpdatesResponse = /** status 200 Successful Response */ ProjectUpdate[]
export type GetProjectUpdatesArgs = {
  projectId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type CreateProjectUpdateResponse = /** status 201 Successful Response */ ProjectUpdate
export type CreateProjectUpdateArgs = {
  projectId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  projectUpdateCreateParams: ProjectUpdateCreateParams
}
export type CreateTaskResponse = /** status 201 Successful Response */ Task[]
export type CreateTaskArgs = {
  projectId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  taskCreateParams: TaskCreateParams
}
export type ListTasksResponse = /** status 200 Successful Response */ CursorPagedListTask
export type ListTasksArgs = {
  projectId: string
  limit?: number
  startingAfter?: string | null
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type GetTaskResponse = /** status 200 Successful Response */ Task
export type GetTaskArgs = {
  projectId: string
  taskId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type UpdateTaskResponse = /** status 200 Successful Response */ Task
export type UpdateTaskArgs = {
  projectId: string
  taskId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  taskUpdateParams: TaskUpdateParams
}
export type DeleteTaskResponse = unknown
export type DeleteTaskArgs = {
  projectId: string
  taskId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type GetSubtasksResponse = /** status 200 Successful Response */ Task[]
export type GetSubtasksArgs = {
  projectId: string
  taskId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type UpdateTaskStatusResponse = /** status 200 Successful Response */ Task
export type UpdateTaskStatusArgs = {
  projectId: string
  taskId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  taskStatus: TaskStatus
}
export type UpdateChecklistResponse = /** status 200 Successful Response */ Task
export type UpdateChecklistArgs = {
  projectId: string
  taskId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  checklist: ChecklistItem[]
}
export type CreateCommentResponse = /** status 201 Successful Response */ TaskComment
export type CreateCommentArgs = {
  projectId: string
  taskId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  commentCreateParams: CommentCreateParams
}
export type ListCommentsResponse = /** status 200 Successful Response */ CursorPagedListTaskComment
export type ListCommentsArgs = {
  projectId: string
  taskId: string
  limit?: number
  startingAfter?: string | null
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type GetCommentResponse = /** status 200 Successful Response */ TaskComment
export type GetCommentArgs = {
  projectId: string
  taskId: string
  commentId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type UpdateCommentResponse = /** status 200 Successful Response */ TaskComment
export type UpdateCommentArgs = {
  projectId: string
  taskId: string
  commentId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type DeleteCommentResponse = unknown
export type DeleteCommentArgs = {
  projectId: string
  taskId: string
  commentId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type ListActivityEventsResponse = /** status 200 Successful Response */ CursorPagedListTaskActivityEvent
export type ListActivityEventsArgs = {
  projectId: string
  taskId: string
  limit?: number
  startingAfter?: string | null
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type CreateWorkOrderResponse = /** status 201 Successful Response */ WorkOrder
export type CreateWorkOrderArgs = {
  projectId: string
  taskId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  workOrderCreateParams: WorkOrderCreateParams
}
export type ListWorkOrdersResponse = /** status 200 Successful Response */ CursorPagedListWorkOrder
export type ListWorkOrdersArgs = {
  projectId: string
  taskId: string
  limit?: number
  startingAfter?: string | null
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type GetWorkOrderResponse = /** status 200 Successful Response */ WorkOrder
export type GetWorkOrderArgs = {
  projectId: string
  taskId: string
  workOrderId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type CancelWorkOrderResponse = /** status 200 Successful Response */ WorkOrder
export type CancelWorkOrderArgs = {
  projectId: string
  taskId: string
  workOrderId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type ApproveWorkOrderResponse = /** status 200 Successful Response */ WorkOrder
export type ApproveWorkOrderArgs = {
  projectId: string
  taskId: string
  workOrderId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  workOrderApproveParams: WorkOrderApproveParams
}
export type RejectWorkOrderResponse = /** status 200 Successful Response */ WorkOrder
export type RejectWorkOrderArgs = {
  projectId: string
  taskId: string
  workOrderId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  workOrderRejectParams: WorkOrderRejectParams
}
export type CreateTaskTemplateResponse = /** status 201 Successful Response */ TaskTemplate
export type CreateTaskTemplateArgs = {
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  taskTemplateCreateParams: TaskTemplateCreateParams
}
export type ListTaskTemplatesResponse = /** status 200 Successful Response */ TaskTemplate[]
export type ListTaskTemplatesArgs = {
  category?: string | null
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type ApplyTemplateToProjectResponse = /** status 201 Successful Response */ Task
export type ApplyTemplateToProjectArgs = {
  projectId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  taskTemplateApplyParams: TaskTemplateApplyParams
}
export type ApplyTemplateToAssetsResponse = /** status 201 Successful Response */ Task[]
export type ApplyTemplateToAssetsArgs = {
  projectId: string
  assetIds?: string[] | null
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  taskTemplateApplyParams: TaskTemplateApplyParams
}
export type GetTasksGroupedByTemplateResponse = /** status 200 Successful Response */ TasksGroupedByTemplate[]
export type GetTasksGroupedByTemplateArgs = {
  projectId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type GetTaskTemplateResponse = /** status 200 Successful Response */ TaskTemplate
export type GetTaskTemplateArgs = {
  templateId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type UpdateTaskTemplateResponse = /** status 200 Successful Response */ TaskTemplate
export type UpdateTaskTemplateArgs = {
  templateId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  taskTemplateCreateParams: TaskTemplateCreateParams
}
export type DeleteTaskTemplateResponse = unknown
export type DeleteTaskTemplateArgs = {
  templateId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type CreateProjectTemplateResponse = /** status 201 Successful Response */ ProjectTemplate
export type CreateProjectTemplateArgs = {
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  projectTemplateCreateParams: ProjectTemplateCreateParams
}
export type ListProjectTemplatesResponse = /** status 200 Successful Response */ ProjectTemplate[]
export type ListProjectTemplatesArgs = {
  category?: string | null
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type GetProjectTemplateResponse = /** status 200 Successful Response */ ProjectTemplate
export type GetProjectTemplateArgs = {
  templateId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type UpdateProjectTemplateResponse = /** status 200 Successful Response */ ProjectTemplate
export type UpdateProjectTemplateArgs = {
  templateId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  projectTemplateCreateParams: ProjectTemplateCreateParams
}
export type DeleteProjectTemplateResponse = unknown
export type DeleteProjectTemplateArgs = {
  templateId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type ApplyProjectTemplateResponse = /** status 201 Successful Response */ Project
export type ApplyProjectTemplateArgs = {
  templateId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  projectTemplateApplyParams: ProjectTemplateApplyParams
}
export type CreateAssetResponse = /** status 200 Successful Response */ Asset
export type CreateAssetArgs = {
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  assetCreateParams: AssetCreateParams
}
export type ListAssetsResponse = /** status 200 Successful Response */ CursorPagedListAsset
export type ListAssetsArgs = {
  siteId?: string | null
  projectId?: string | null
  organizationId?: string | null
  limit?: number
  startingAfter?: string | null
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type BulkUpdateAssetsResponse = /** status 200 Successful Response */ AssetBulkUpdateResult
export type BulkUpdateAssetsArgs = {
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  assetBulkUpdateParams: AssetBulkUpdateParams
}
export type ReconcileAssetsResponse = /** status 200 Successful Response */ AssetReconcileResult
export type ReconcileAssetsArgs = {
  siteId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  assetReconcileParams: AssetReconcileParams
}
export type DeleteAssetResponse = unknown
export type DeleteAssetArgs = {
  assetId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type ListGroupedByAssetResponse = /** status 200 Successful Response */ TasksGroupedByAsset[]
export type ListGroupedByAssetArgs = {
  projectId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type SearchWithinBoundsResponse = /** status 200 Successful Response */ CursorPagedListAsset
export type SearchWithinBoundsArgs = {
  projectId: string
  minLat: number
  maxLat: number
  minLng: number
  maxLng: number
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type ListArAssetsResponse = /** status 200 Successful Response */ CursorPagedListAsset
export type ListArAssetsArgs = {
  projectId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type SyncFromMarkerResponse = /** status 200 Successful Response */ Asset
export type SyncFromMarkerArgs = {
  projectId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  assetCreateParams: AssetCreateParams
}
export type RetrieveByMarkerIdResponse = /** status 200 Successful Response */ Asset
export type RetrieveByMarkerIdArgs = {
  projectId: string
  arMarkerId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type ListProjectAssetsResponse = /** status 200 Successful Response */ CursorPagedListAsset
export type ListProjectAssetsArgs = {
  projectId: string
  limit?: number
  startingAfter?: string | null
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type LinkAssetToProjectResponse = unknown
export type LinkAssetToProjectArgs = {
  projectId: string
  assetId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type RetrieveAssetResponse = /** status 200 Successful Response */ Asset
export type RetrieveAssetArgs = {
  projectId: string
  assetId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type UpdateAssetResponse = /** status 200 Successful Response */ Asset
export type UpdateAssetArgs = {
  projectId: string
  assetId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  assetUpdateParams: AssetUpdateParams
}
export type UnlinkAssetFromProjectResponse = unknown
export type UnlinkAssetFromProjectArgs = {
  projectId: string
  assetId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type ListAssetTasksResponse = /** status 200 Successful Response */ CursorPagedListTask
export type ListAssetTasksArgs = {
  projectId: string
  assetId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type ApplyTemplateToAssetResponse = /** status 201 Successful Response */ Task
export type ApplyTemplateToAssetArgs = {
  projectId: string
  assetId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  taskTemplateApplyParams: TaskTemplateApplyParams
}
export type CreateAttachmentUploadUrlResponse = /** status 201 Successful Response */ {
  [key: string]: string
}
export type CreateAttachmentUploadUrlArgs = {
  entityId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  attachmentCreateParams: AttachmentCreateParams
}
export type GetAttachmentDownloadUrlResponse = /** status 200 Successful Response */ {
  [key: string]: string
}
export type GetAttachmentDownloadUrlArgs = {
  entityId: string
  attachmentId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type GetAttachmentResponse = /** status 200 Successful Response */ Attachment
export type GetAttachmentArgs = {
  entityId: string
  attachmentId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type DeleteAttachmentResponse = unknown
export type DeleteAttachmentArgs = {
  entityId: string
  attachmentId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type ListAttachmentsResponse = /** status 200 Successful Response */ Attachment[]
export type ListAttachmentsArgs = {
  entityId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type CreateDocumentResponse = /** status 201 Successful Response */ Document
export type CreateDocumentArgs = {
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  documentCreateParams: DocumentCreateParams
}
export type ListDocumentsResponse = /** status 200 Successful Response */ CursorPagedListDocument
export type ListDocumentsArgs = {
  limit?: number
  startingAfter?: string | null
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type GetDocumentResponse = /** status 200 Successful Response */ Document
export type GetDocumentArgs = {
  documentId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type UpdateDocumentResponse = /** status 200 Successful Response */ Document
export type UpdateDocumentArgs = {
  documentId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  documentUpdateParams: DocumentUpdateParams
}
export type DeleteDocumentResponse = unknown
export type DeleteDocumentArgs = {
  documentId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type CreateDocumentUploadUrlResponse = /** status 201 Successful Response */ {
  [key: string]: string
}
export type CreateDocumentUploadUrlArgs = {
  documentId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type GetDocumentDownloadUrlResponse = /** status 200 Successful Response */ {
  [key: string]: string
}
export type GetDocumentDownloadUrlArgs = {
  documentId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type CreatePlanResponse = /** status 201 Successful Response */ Plan
export type CreatePlanArgs = {
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  planCreateParams: PlanCreateParams
}
export type ListPlansResponse = /** status 200 Successful Response */ CursorPagedListPlan
export type ListPlansArgs = {
  status?: PlanStatus | null
  limit?: number
  startingAfter?: string | null
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type PreviewPlanResponse = /** status 200 Successful Response */ PlanPreview
export type PreviewPlanArgs = {
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  planPreviewParams: PlanPreviewParams
}
export type GetPlanResponse = /** status 200 Successful Response */ Plan
export type GetPlanArgs = {
  planId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type UpdatePlanResponse = /** status 200 Successful Response */ Plan
export type UpdatePlanArgs = {
  planId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  planUpdateParams: PlanUpdateParams
}
export type PausePlanResponse = /** status 200 Successful Response */ Plan
export type PausePlanArgs = {
  planId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type ResumePlanResponse = /** status 200 Successful Response */ Plan
export type ResumePlanArgs = {
  planId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type ArchivePlanResponse = /** status 200 Successful Response */ Plan
export type ArchivePlanArgs = {
  planId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type GetCyclesResponse = /** status 200 Successful Response */ PlanCycles
export type GetCyclesArgs = {
  planId: string
  pastLimit?: number
  upcomingLimit?: number
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type GetChargerPlansResponse = /** status 200 Successful Response */ ChargerPlans
export type GetChargerPlansArgs = {
  chargerId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type ListAddressesResponse = /** status 200 Successful Response */ EmailIntakeAddress[]
export type ListAddressesArgs = {
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type CreateAddressResponse = /** status 201 Successful Response */ EmailIntakeAddress
export type CreateAddressArgs = {
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  emailIntakeAddressCreateParams: EmailIntakeAddressCreateParams
}
export type GetAddressResponse = /** status 200 Successful Response */ EmailIntakeAddress
export type GetAddressArgs = {
  alias: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type UpdateAddressResponse = /** status 200 Successful Response */ EmailIntakeAddress
export type UpdateAddressArgs = {
  alias: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  emailIntakeAddressUpdateParams: EmailIntakeAddressUpdateParams
}
export type DeleteAddressResponse = unknown
export type DeleteAddressArgs = {
  alias: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type ListTicketAgentSessionsResponse = /** status 200 Successful Response */ CursorPagedListAgentSession
export type ListTicketAgentSessionsArgs = {
  ticketId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type CreateTicketAgentSessionResponse = /** status 201 Successful Response */ AgentSession
export type CreateTicketAgentSessionArgs = {
  ticketId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  agentSessionCreateParams: AgentSessionCreateParams
}
export type GetAgentSessionResponse = /** status 200 Successful Response */ AgentSession
export type GetAgentSessionArgs = {
  sessionId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type UpdateAgentSessionResponse = /** status 200 Successful Response */ AgentSession
export type UpdateAgentSessionArgs = {
  sessionId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  agentSessionUpdateParams: AgentSessionUpdateParams
}
export type ListAgentActivitiesResponse = /** status 200 Successful Response */ CursorPagedListAgentActivity
export type ListAgentActivitiesArgs = {
  sessionId: string
  includeEphemeral?: boolean
  limit?: number
  startingAfter?: string | null
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
}
export type CreateAgentActivityResponse = /** status 201 Successful Response */ AgentActivity
export type CreateAgentActivityArgs = {
  sessionId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  agentActivityCreateBody: AgentActivityCreateBody
}
export type CreateAgentPromptResponse = /** status 201 Successful Response */ AgentActivity
export type CreateAgentPromptArgs = {
  sessionId: string
  /** Organization to act in, when the caller may act for more than one; defaults to the credential's own organization. */
  'X-Organization-Id'?: string
  agentPromptCreateParams: AgentPromptCreateParams
}
export type TicketPrefix = {
  prefix: string
  customized: boolean
}
export type ValidationError = {
  loc: (string | number)[]
  msg: string
  type: string
  ctx?: object
}
export type HttpValidationError = {
  detail?: ValidationError[]
}
export type TicketPrefixUpdateParams = {
  prefix?: string | null
}
export type TicketPrefixAssignParams = {
  organizationNm?: string | null
}
export type TaskStatus = 'TODO' | 'IN_PROGRESS' | 'BLOCKED' | 'DONE'
export type TaskPriority = 'LOW' | 'MEDIUM' | 'HIGH' | 'URGENT'
export type ChecklistItem = {
  id?: string | null
  text?: string | null
  completed?: boolean | null
  sortOrder?: number | null
}
export type ReferenceLink = {
  label?: string | null
  url?: string | null
}
export type AssetType =
  | 'EVSE'
  | 'BESS'
  | 'GENSET'
  | 'PANEL'
  | 'INVERTER'
  | 'METER'
  | 'TRANSFORMER'
  | 'VEHICLE'
  | 'CONDUIT'
  | 'PARKING_SPOT'
  | 'STORAGE_CONTAINER'
  | 'BUILDING'
  | 'SOLAR_PANEL'
  | 'OTHER'
export type AssetReference = {
  id?: string | null
  name?: string | null
  type?: AssetType | null
}
export type Task = {
  projectId?: string | null
  id?: string | null
  ticketId?: string | null
  title?: string | null
  description?: string | null
  emoji?: string | null
  status?: TaskStatus | null
  priority?: TaskPriority | null
  labels?: string[] | null
  checklist?: ChecklistItem[] | null
  referenceLinks?: ReferenceLink[] | null
  assets?: AssetReference[] | null
  documentIds?: string[] | null
  templateId?: string | null
  templateName?: string | null
  templateVersion?: number | null
  planId?: string | null
  planName?: string | null
  occurrenceDate?: string | null
  workOrderNumber?: string | null
  hasPendingWorkOrder?: boolean | null
  dependsOnTaskId?: string | null
  parentTaskId?: string | null
  parentTaskIndexPk?: string | null
  assigneeId?: string | null
  delegatedAgentId?: string | null
  dueDate?: string | null
  estimatedHours?: number | null
  actualHours?: number | null
  sortOrder?: number | null
  createdBy?: string | null
  createdAt?: string | null
  updatedAt?: string | null
  organizationId?: string | null
  siteId?: string | null
  source?: string | null
  reporterEmail?: string | null
  reporterName?: string | null
}
export type TaskCreateParams = {
  title?: string | null
  description?: string | null
  emoji?: string | null
  priority?: TaskPriority | null
  labels?: string[] | null
  checklistItems?: string[] | null
  referenceLinks?: ReferenceLink[] | null
  templateId?: string | null
  assets?: AssetReference[] | null
  documentIds?: string[] | null
  dependsOnTaskId?: string | null
  parentTaskId?: string | null
  workOrderNumber?: string | null
  assigneeId?: string | null
  delegatedAgentId?: string | null
  dueDate?: string | null
  estimatedHours?: number | null
  sortOrder?: number | null
  siteId?: string | null
}
export type CursorLinks = {
  current?: string | null
  next?: string | null
  prev?: string | null
}
export type CursorMeta = {
  total?: number | null
  pageSize?: number | null
  last?: boolean | null
}
export type CursorPagedListTask = {
  data: Task[]
  links: CursorLinks
  meta: CursorMeta
}
export type TaskUpdateParams = {
  title?: string | null
  description?: string | null
  emoji?: string | null
  status?: TaskStatus | null
  priority?: TaskPriority | null
  labels?: string[] | null
  referenceLinks?: ReferenceLink[] | null
  assets?: AssetReference[] | null
  documentIds?: string[] | null
  workOrderNumber?: string | null
  assigneeId?: string | null
  delegatedAgentId?: string | null
  dueDate?: string | null
  estimatedHours?: number | null
  actualHours?: number | null
  sortOrder?: number | null
  parentTaskId?: string | null
  siteId?: string | null
  projectId?: string | null
}
export type ProjectType = 'STANDARD' | 'ADHOC'
export type ProjectStatus = 'ACTIVE' | 'UPCOMING' | 'COMPLETED' | 'ON_HOLD'
export type ProjectResource = {
  name?: string | null
  key?: string | null
  type?: string | null
}
export type Project = {
  id?: string | null
  organizationId?: string | null
  projectType?: ProjectType | null
  name?: string | null
  description?: string | null
  emoji?: string | null
  status?: ProjectStatus | null
  folder?: string | null
  dueDate?: string | null
  siteId?: string | null
  address?: string | null
  latitude?: number | null
  longitude?: number | null
  taskCount?: number | null
  completedTasks?: number | null
  labels?: string[] | null
  assigneeIds?: string[] | null
  projectLeadId?: string | null
  projectLeadName?: string | null
  documentIds?: string[] | null
  resources?: ProjectResource[] | null
  createdBy?: string | null
  createdAt?: string | null
  updatedAt?: string | null
  orgProjectTypeSortKey?: string | null
}
export type ProjectCreateParams = {
  name?: string | null
  description?: string | null
  emoji?: string | null
  folder?: string | null
  dueDate?: string | null
  siteId?: string | null
  address?: string | null
  latitude?: number | null
  longitude?: number | null
  labels?: string[] | null
  assigneeIds?: string[] | null
  projectLeadId?: string | null
  projectLeadName?: string | null
  documentIds?: string[] | null
}
export type CursorPagedListProject = {
  data: Project[]
  links: CursorLinks
  meta: CursorMeta
}
export type ProjectUpdateParams = {
  name?: string | null
  description?: string | null
  emoji?: string | null
  status?: ProjectStatus | null
  folder?: string | null
  dueDate?: string | null
  siteId?: string | null
  address?: string | null
  latitude?: number | null
  longitude?: number | null
  labels?: string[] | null
  assigneeIds?: string[] | null
  projectLeadId?: string | null
  projectLeadName?: string | null
  documentIds?: string[] | null
}
export type ProjectUpdate = {
  projectId?: string | null
  id?: string | null
  updateType?: string | null
  content?: string | null
  userId?: string | null
  userName?: string | null
  createdAt?: string | null
}
export type ProjectUpdateCreateParams = {
  content?: string | null
  updateType?: string | null
}
export type TaskComment = {
  taskId?: string | null
  id?: string | null
  projectId?: string | null
  content?: string | null
  authorId?: string | null
  authorOrganizationId?: string | null
  visibility?: string | null
  authorName?: string | null
  authorEmail?: string | null
  source?: string | null
  parentCommentId?: string | null
  attachmentKeys?: string[] | null
  createdAt?: string | null
  updatedAt?: string | null
}
export type CommentCreateParams = {
  content?: string | null
  attachmentKeys?: string[] | null
  parentCommentId?: string | null
}
export type CursorPagedListTaskComment = {
  data: TaskComment[]
  links: CursorLinks
  meta: CursorMeta
}
export type TaskActivityEventType =
  | 'STATUS_CHANGED'
  | 'ASSIGNEE_CHANGED'
  | 'PRIORITY_CHANGED'
  | 'LABELS_CHANGED'
  | 'CREATED'
  | 'DELEGATED'
export type TaskActivityEvent = {
  id?: string | null
  taskId?: string | null
  projectId?: string | null
  organizationId?: string | null
  type?: TaskActivityEventType | null
  actorUserId?: string | null
  actorDisplayName?: string | null
  payload?: {
    [key: string]: unknown
  } | null
  createdAt?: string | null
}
export type CursorPagedListTaskActivityEvent = {
  data: TaskActivityEvent[]
  links: CursorLinks
  meta: CursorMeta
}
export type WorkOrderStatus = 'PENDING' | 'APPROVED' | 'REJECTED' | 'CANCELLED'
export type WorkOrder = {
  id?: string | null
  taskId?: string | null
  projectId?: string | null
  organizationId?: string | null
  content?: string | null
  attachmentKeys?: string[] | null
  estimateCurrency?: string | null
  estimateAmount?: number | null
  status?: WorkOrderStatus | null
  authorId?: string | null
  workOrderId?: string | null
  externalWorkOrderNumber?: string | null
  metadata?: {
    [key: string]: string
  } | null
  rejectionReason?: string | null
  reviewedByUserId?: string | null
  reviewedAt?: string | null
  cancelledAt?: string | null
  createdAt?: string | null
  updatedAt?: string | null
}
export type WorkOrderCreateParams = {
  content?: string | null
  attachmentKeys?: string[] | null
  estimateCurrency?: string | null
  estimateAmount?: number | string | null
}
export type CursorPagedListWorkOrder = {
  data: WorkOrder[]
  links: CursorLinks
  meta: CursorMeta
}
export type WorkOrderApproveParams = {
  workOrderId?: string | null
  externalWorkOrderNumber?: string | null
  metadata?: {
    [key: string]: string
  } | null
}
export type WorkOrderRejectParams = {
  reason?: string | null
}
export type TaskTemplate = {
  organizationId?: string | null
  id?: string | null
  name?: string | null
  description?: string | null
  applicableAssetTypes?: AssetType[] | null
  category?: string | null
  taskTitle?: string | null
  taskDescription?: string | null
  defaultPriority?: TaskPriority | null
  defaultLabels?: string[] | null
  checklistItems?: string[] | null
  referenceLinks?: ReferenceLink[] | null
  version?: number | null
  isSystem?: boolean | null
  usageCount?: number | null
  createdBy?: string | null
  createdAt?: string | null
  updatedAt?: string | null
}
export type TaskTemplateCreateParams = {
  name?: string | null
  description?: string | null
  applicableAssetTypes?: AssetType[] | null
  category?: string | null
  taskTitle?: string | null
  taskDescription?: string | null
  defaultPriority?: TaskPriority | null
  defaultLabels?: string[] | null
  checklistItems?: string[] | null
  referenceLinks?: ReferenceLink[] | null
}
export type TaskTemplateApplyParams = {
  templateId?: string | null
  titleOverride?: string | null
  assigneeId?: string | null
}
export type TasksGroupedByTemplate = {
  templateId?: string | null
  templateName?: string | null
  tasks?: Task[] | null
  totalTasks?: number | null
  completedTasks?: number | null
  completionPercent?: number | null
}
export type AssetTemplateItem = {
  type?: string | null
  namePattern?: string | null
  count?: number | null
  manufacturer?: string | null
  model?: string | null
  taskTemplateIds?: string[] | null
}
export type TaskTemplateMapping = {
  assetType?: string | null
  taskTemplateId?: string | null
}
export type ProjectTemplate = {
  organizationId?: string | null
  id?: string | null
  name?: string | null
  description?: string | null
  category?: string | null
  assets?: AssetTemplateItem[] | null
  taskMappings?: TaskTemplateMapping[] | null
  projectTaskTemplateIds?: string[] | null
  defaultLabels?: string[] | null
  isSystem?: boolean | null
  usageCount?: number | null
  createdBy?: string | null
  createdAt?: string | null
  updatedAt?: string | null
}
export type ProjectTemplateCreateParams = {
  name?: string | null
  description?: string | null
  category?: string | null
  assets?: AssetTemplateItem[] | null
  taskMappings?: TaskTemplateMapping[] | null
  projectTaskTemplateIds?: string[] | null
  defaultLabels?: string[] | null
}
export type ProjectTemplateApplyParams = {
  projectName?: string | null
  description?: string | null
  dueDate?: string | null
  siteId?: string | null
  address?: string | null
  latitude?: number | null
  longitude?: number | null
  folder?: string | null
  additionalLabels?: string[] | null
  assigneeIds?: string[] | null
}
export type AssetStatus =
  | 'PENDING'
  | 'INSTALLED'
  | 'CONFIGURED'
  | 'TESTING'
  | 'OPERATIONAL'
  | 'IN_MAINTENANCE'
  | 'FAILED'
  | 'DECOMMISSIONED'
export type GeoJsonGeometry = {
  type?: string | null
  coordinates?: unknown[] | null
}
export type Asset = {
  siteId?: string | null
  id?: string | null
  type?: AssetType | null
  name?: string | null
  description?: string | null
  notes?: string | null
  manufacturer?: string | null
  model?: string | null
  serialNumber?: string | null
  firmwareVersion?: string | null
  status?: AssetStatus | null
  installDate?: string | null
  warrantyExpiry?: string | null
  location?: string | null
  latitude?: number | null
  longitude?: number | null
  altitude?: number | null
  heading?: number | null
  pitch?: number | null
  accuracy?: number | null
  screenX?: number | null
  screenY?: number | null
  photoUri?: string | null
  arMarkerId?: string | null
  floor?: number | null
  externalId?: string | null
  shape?: GeoJsonGeometry | null
  metadata?: {
    [key: string]: string
  } | null
  taskCount?: number | null
  completedTasks?: number | null
  createdBy?: string | null
  createdAt?: string | null
  updatedAt?: string | null
  deletedAt?: string | null
  organizationId?: string | null
}
export type AssetCreateParams = {
  type?: AssetType | null
  name?: string | null
  siteId?: string | null
  description?: string | null
  notes?: string | null
  manufacturer?: string | null
  model?: string | null
  serialNumber?: string | null
  firmwareVersion?: string | null
  installDate?: string | null
  warrantyExpiry?: string | null
  location?: string | null
  latitude?: number | null
  longitude?: number | null
  altitude?: number | null
  heading?: number | null
  pitch?: number | null
  accuracy?: number | null
  screenX?: number | null
  screenY?: number | null
  photoUri?: string | null
  arMarkerId?: string | null
  floor?: number | null
  externalId?: string | null
  shape?: GeoJsonGeometry | null
  metadata?: {
    [key: string]: string
  } | null
}
export type CursorPagedListAsset = {
  data: Asset[]
  links: CursorLinks
  meta: CursorMeta
}
export type AssetBulkUpdateResult = {
  updated?: Asset[] | null
  notFound?: string[] | null
}
export type AssetBulkUpdateItem = {
  type?: AssetType | null
  name?: string | null
  siteId?: string | null
  description?: string | null
  notes?: string | null
  manufacturer?: string | null
  model?: string | null
  serialNumber?: string | null
  firmwareVersion?: string | null
  installDate?: string | null
  warrantyExpiry?: string | null
  location?: string | null
  latitude?: number | null
  longitude?: number | null
  altitude?: number | null
  heading?: number | null
  pitch?: number | null
  accuracy?: number | null
  screenX?: number | null
  screenY?: number | null
  photoUri?: string | null
  arMarkerId?: string | null
  floor?: number | null
  externalId?: string | null
  shape?: GeoJsonGeometry | null
  metadata?: {
    [key: string]: string
  } | null
  status?: AssetStatus | null
  assetId?: string | null
}
export type AssetBulkUpdateParams = {
  updates?: AssetBulkUpdateItem[] | null
}
export type AssetReconcileResult = {
  created?: Asset[] | null
  updated?: Asset[] | null
  deleted?: string[] | null
  unchanged?: number
}
export type AssetReconcileItem = {
  type?: AssetType | null
  name?: string | null
  siteId?: string | null
  description?: string | null
  notes?: string | null
  manufacturer?: string | null
  model?: string | null
  serialNumber?: string | null
  firmwareVersion?: string | null
  installDate?: string | null
  warrantyExpiry?: string | null
  location?: string | null
  latitude?: number | null
  longitude?: number | null
  altitude?: number | null
  heading?: number | null
  pitch?: number | null
  accuracy?: number | null
  screenX?: number | null
  screenY?: number | null
  photoUri?: string | null
  arMarkerId?: string | null
  floor?: number | null
  externalId?: string | null
  shape?: GeoJsonGeometry | null
  metadata?: {
    [key: string]: string
  } | null
  status?: AssetStatus | null
  assetId?: string | null
}
export type AssetReconcileParams = {
  items?: AssetReconcileItem[] | null
}
export type TasksGroupedByAsset = {
  asset?: Asset | null
  tasks?: Task[] | null
  totalTasks?: number | null
  completedTasks?: number | null
  completionPercent?: number | null
}
export type AssetUpdateParams = {
  type?: AssetType | null
  name?: string | null
  siteId?: string | null
  description?: string | null
  notes?: string | null
  manufacturer?: string | null
  model?: string | null
  serialNumber?: string | null
  firmwareVersion?: string | null
  installDate?: string | null
  warrantyExpiry?: string | null
  location?: string | null
  latitude?: number | null
  longitude?: number | null
  altitude?: number | null
  heading?: number | null
  pitch?: number | null
  accuracy?: number | null
  screenX?: number | null
  screenY?: number | null
  photoUri?: string | null
  arMarkerId?: string | null
  floor?: number | null
  externalId?: string | null
  shape?: GeoJsonGeometry | null
  metadata?: {
    [key: string]: string
  } | null
  status?: AssetStatus | null
}
export type AttachmentCreateParams = {
  fileName?: string | null
  contentType?: string | null
  fileSize?: number | null
  entityType?: string | null
  entityId?: string | null
}
export type Attachment = {
  entityId?: string | null
  id?: string | null
  filename?: string | null
  contentType?: string | null
  fileSize?: number | null
  s3Bucket?: string | null
  s3Key?: string | null
  uploadedBy?: string | null
  createdAt?: string | null
  organizationId?: string | null
}
export type Document = {
  organizationId?: string | null
  id?: string | null
  name?: string | null
  description?: string | null
  type?: string | null
  category?: string | null
  tags?: string[] | null
  url?: string | null
  s3Bucket?: string | null
  s3Key?: string | null
  filename?: string | null
  contentType?: string | null
  fileSize?: number | null
  version?: number | null
  ownerId?: string | null
  createdBy?: string | null
  createdAt?: string | null
  updatedAt?: string | null
}
export type DocumentCreateParams = {
  name?: string | null
  description?: string | null
  type?: string | null
  category?: string | null
  tags?: string[] | null
  url?: string | null
  filename?: string | null
  contentType?: string | null
  fileSize?: number | null
}
export type CursorPagedListDocument = {
  data: Document[]
  links: CursorLinks
  meta: CursorMeta
}
export type DocumentUpdateParams = {
  name?: string | null
  description?: string | null
  type?: string | null
  category?: string | null
  tags?: string[] | null
  url?: string | null
}
export type PlanAssetType = 'CHARGER'
export type PlanMembership = 'SITE' | 'ASSET_LIST'
export type RecurrenceType = 'DAILY' | 'WEEKLY' | 'WEEKDAYS' | 'CUSTOM' | 'MONTHLY' | 'YEARLY'
export type PlanStatus = 'ACTIVE' | 'PAUSED' | 'ARCHIVED'
export type Plan = {
  id?: string | null
  organizationId?: string | null
  name?: string | null
  description?: string | null
  assetType?: PlanAssetType | null
  membership?: PlanMembership | null
  siteId?: string | null
  assetIds?: string[] | null
  recurrenceRule?: string | null
  recurrenceType?: RecurrenceType | null
  startDate?: string | null
  dueTime?: string | null
  timezone?: string | null
  endDate?: string | null
  neverEnding?: boolean | null
  leadDays?: number | null
  templateId?: string | null
  defaultAssigneeId?: string | null
  assigneeInvalid?: boolean | null
  status?: PlanStatus | null
  nextOccurrenceDate?: string | null
  nextOccurrenceAt?: string | null
  nextDueAt?: string | null
  lastOpenedOccurrenceDate?: string | null
  firstCycleInsideLeadWindow?: boolean | null
  createdBy?: string | null
  createdAt?: string | null
  updatedAt?: string | null
}
export type PlanCreateParams = {
  name?: string | null
  description?: string | null
  assetType?: PlanAssetType | null
  membership?: PlanMembership | null
  siteId?: string | null
  assetIds?: string[] | null
  recurrenceRule?: string | null
  recurrenceType?: RecurrenceType | null
  startDate?: string | null
  dueTime?: string | null
  timezone?: string | null
  endDate?: string | null
  neverEnding?: boolean | null
  leadDays?: number | null
  templateId?: string | null
  defaultAssigneeId?: string | null
}
export type CursorPagedListPlan = {
  data: Plan[]
  links: CursorLinks
  meta: CursorMeta
}
export type CyclePreview = {
  occurrenceDate: string
  dueAt: string
  opensAt: string
  ticketCount?: number | null
  insideLeadWindow: boolean
}
export type PlanPreview = {
  assetCount?: number | null
  cycles: CyclePreview[]
  firstCycleInsideLeadWindow: boolean
}
export type PlanPreviewParams = {
  assetType?: PlanAssetType | null
  membership?: PlanMembership | null
  siteId?: string | null
  assetIds?: string[] | null
  recurrenceRule?: string | null
  startDate?: string | null
  dueTime?: string | null
  timezone?: string | null
  endDate?: string | null
  neverEnding?: boolean | null
  leadDays?: number | null
  maxOccurrences?: number | null
  horizonDays?: number | null
}
export type PlanUpdateParams = {
  name?: string | null
  description?: string | null
  assetType?: PlanAssetType | null
  membership?: PlanMembership | null
  siteId?: string | null
  assetIds?: string[] | null
  recurrenceRule?: string | null
  recurrenceType?: RecurrenceType | null
  startDate?: string | null
  dueTime?: string | null
  timezone?: string | null
  endDate?: string | null
  neverEnding?: boolean | null
  leadDays?: number | null
  templateId?: string | null
  defaultAssigneeId?: string | null
}
export type Cycle = {
  planId?: string | null
  occurrenceDate?: string | null
  taskProjectId?: string | null
  dueAt?: string | null
  openedAt?: string | null
  expectedCount?: number | null
  doneCount?: number | null
  skippedCount?: number | null
  openCount?: number | null
  overdue?: boolean | null
}
export type PlanCycles = {
  open: Cycle[]
  upcoming: CyclePreview[]
  past: Cycle[]
}
export type ChargerPlanCoverage = {
  planId?: string | null
  planName?: string | null
  planStatus?: PlanStatus | null
  coveredVia?: PlanMembership | null
  nextOccurrenceDate?: string | null
  nextDueAt?: string | null
  openOccurrenceDate?: string | null
  openTicketId?: string | null
  openTicketProjectId?: string | null
}
export type ChargerPlans = {
  chargerId: string
  plans: ChargerPlanCoverage[]
}
export type EmailIntakeAddress = {
  alias?: string | null
  address?: string | null
  organizationId?: string | null
  enabled: boolean
  defaultAssigneeId?: string | null
  defaultPriority?: TaskPriority | null
  defaultLabels?: string[] | null
  allowedSenderDomains?: string[] | null
  createdBy?: string | null
  createdAt?: string | null
  updatedAt?: string | null
}
export type EmailIntakeAddressCreateParams = {
  alias?: string | null
  defaultAssigneeId?: string | null
  defaultPriority?: TaskPriority | null
  defaultLabels?: string[] | null
  allowedSenderDomains?: string[] | null
}
export type EmailIntakeAddressUpdateParams = {
  enabled?: boolean | null
  defaultAssigneeId?: string | null
  defaultPriority?: TaskPriority | null
  defaultLabels?: string[] | null
  allowedSenderDomains?: string[] | null
}
export type AgentSessionSource = 'delegation' | 'mention'
export type SessionState = 'pending' | 'active' | 'awaiting_input' | 'complete' | 'error' | 'cancelled'
export type AgentSession = {
  id: string
  organizationId: string
  taskId: string
  agentId: string
  createdByUserId: string
  onBehalfOfUserId: string
  source: AgentSessionSource
  externalId?: string | null
  state: SessionState
  notResponding: boolean
  stale: boolean
  createdAt: string
  updatedAt: string
  endedAt?: string | null
}
export type CursorPagedListAgentSession = {
  data: AgentSession[]
  links: CursorLinks
  meta: CursorMeta
}
export type AgentSessionCreateParams = {
  agentId: string
}
export type AgentSessionUpdateParams = {
  externalId?: string | null
}
export type AgentActivityType = 'thought' | 'action' | 'elicitation' | 'response' | 'error' | 'prompt'
export type AgentActivitySignal = 'stop' | 'select'
export type ActorKind = 'agent' | 'user'
export type AgentActivity = {
  id: string
  sessionId: string
  type: AgentActivityType
  body?: string | null
  action?: string | null
  parameter?: string | null
  result?: string | null
  signal?: AgentActivitySignal | null
  signalMetadata?: {
    [key: string]: unknown
  } | null
  ephemeral: boolean
  actorId: string
  actorKind: ActorKind
  answersActivityId?: string | null
  createdAt: string
}
export type CursorPagedListAgentActivity = {
  data: AgentActivity[]
  links: CursorLinks
  meta: CursorMeta
}
export type ThoughtActivity = {
  type: 'thought'
  body: string
  ephemeral?: boolean
}
export type ActionActivity = {
  type: 'action'
  action: string
  parameter?: string | null
  result?: string | null
  body?: string | null
  ephemeral?: boolean
}
export type SelectOption = {
  label: string
  value: string
}
export type SelectSignalMetadata = {
  options: SelectOption[]
}
export type ElicitationActivity = {
  type: 'elicitation'
  body: string
  signal?: 'select' | null
  signalMetadata?: SelectSignalMetadata | null
}
export type ResponseActivity = {
  type: 'response'
  body: string
}
export type ErrorActivity = {
  type: 'error'
  body: string
}
export type AgentActivityCreateBody =
  | ThoughtActivity
  | ActionActivity
  | ElicitationActivity
  | ResponseActivity
  | ErrorActivity
export type AgentPromptCreateParams = {
  body?: string | null
  signal?: 'stop' | null
  answersActivityId?: string | null
  value?: string | null
}
export const {
  useGetPrefixQuery,
  useLazyGetPrefixQuery,
  useUpdatePrefixMutation,
  useAssignPrefixMutation,
  useCreateTicketMutation,
  useListTicketsQuery,
  useLazyListTicketsQuery,
  useGetTicketQuery,
  useLazyGetTicketQuery,
  useUpdateTicketMutation,
  useDeleteTicketMutation,
  useCreateProjectMutation,
  useListProjectsQuery,
  useLazyListProjectsQuery,
  useGetProjectQuery,
  useLazyGetProjectQuery,
  useUpdateProjectMutation,
  useDeleteProjectMutation,
  useGetProjectUpdatesQuery,
  useLazyGetProjectUpdatesQuery,
  useCreateProjectUpdateMutation,
  useCreateTaskMutation,
  useListTasksQuery,
  useLazyListTasksQuery,
  useGetTaskQuery,
  useLazyGetTaskQuery,
  useUpdateTaskMutation,
  useDeleteTaskMutation,
  useGetSubtasksQuery,
  useLazyGetSubtasksQuery,
  useUpdateTaskStatusMutation,
  useUpdateChecklistMutation,
  useCreateCommentMutation,
  useListCommentsQuery,
  useLazyListCommentsQuery,
  useGetCommentQuery,
  useLazyGetCommentQuery,
  useUpdateCommentMutation,
  useDeleteCommentMutation,
  useListActivityEventsQuery,
  useLazyListActivityEventsQuery,
  useCreateWorkOrderMutation,
  useListWorkOrdersQuery,
  useLazyListWorkOrdersQuery,
  useGetWorkOrderQuery,
  useLazyGetWorkOrderQuery,
  useCancelWorkOrderMutation,
  useApproveWorkOrderMutation,
  useRejectWorkOrderMutation,
  useCreateTaskTemplateMutation,
  useListTaskTemplatesQuery,
  useLazyListTaskTemplatesQuery,
  useApplyTemplateToProjectMutation,
  useApplyTemplateToAssetsMutation,
  useGetTasksGroupedByTemplateQuery,
  useLazyGetTasksGroupedByTemplateQuery,
  useGetTaskTemplateQuery,
  useLazyGetTaskTemplateQuery,
  useUpdateTaskTemplateMutation,
  useDeleteTaskTemplateMutation,
  useCreateProjectTemplateMutation,
  useListProjectTemplatesQuery,
  useLazyListProjectTemplatesQuery,
  useGetProjectTemplateQuery,
  useLazyGetProjectTemplateQuery,
  useUpdateProjectTemplateMutation,
  useDeleteProjectTemplateMutation,
  useApplyProjectTemplateMutation,
  useCreateAssetMutation,
  useListAssetsQuery,
  useLazyListAssetsQuery,
  useBulkUpdateAssetsMutation,
  useReconcileAssetsMutation,
  useDeleteAssetMutation,
  useListGroupedByAssetQuery,
  useLazyListGroupedByAssetQuery,
  useSearchWithinBoundsQuery,
  useLazySearchWithinBoundsQuery,
  useListArAssetsQuery,
  useLazyListArAssetsQuery,
  useSyncFromMarkerMutation,
  useRetrieveByMarkerIdQuery,
  useLazyRetrieveByMarkerIdQuery,
  useListProjectAssetsQuery,
  useLazyListProjectAssetsQuery,
  useLinkAssetToProjectMutation,
  useRetrieveAssetQuery,
  useLazyRetrieveAssetQuery,
  useUpdateAssetMutation,
  useUnlinkAssetFromProjectMutation,
  useListAssetTasksQuery,
  useLazyListAssetTasksQuery,
  useApplyTemplateToAssetMutation,
  useCreateAttachmentUploadUrlMutation,
  useGetAttachmentDownloadUrlQuery,
  useLazyGetAttachmentDownloadUrlQuery,
  useGetAttachmentQuery,
  useLazyGetAttachmentQuery,
  useDeleteAttachmentMutation,
  useListAttachmentsQuery,
  useLazyListAttachmentsQuery,
  useCreateDocumentMutation,
  useListDocumentsQuery,
  useLazyListDocumentsQuery,
  useGetDocumentQuery,
  useLazyGetDocumentQuery,
  useUpdateDocumentMutation,
  useDeleteDocumentMutation,
  useCreateDocumentUploadUrlMutation,
  useGetDocumentDownloadUrlQuery,
  useLazyGetDocumentDownloadUrlQuery,
  useCreatePlanMutation,
  useListPlansQuery,
  useLazyListPlansQuery,
  usePreviewPlanMutation,
  useGetPlanQuery,
  useLazyGetPlanQuery,
  useUpdatePlanMutation,
  usePausePlanMutation,
  useResumePlanMutation,
  useArchivePlanMutation,
  useGetCyclesQuery,
  useLazyGetCyclesQuery,
  useGetChargerPlansQuery,
  useLazyGetChargerPlansQuery,
  useListAddressesQuery,
  useLazyListAddressesQuery,
  useCreateAddressMutation,
  useGetAddressQuery,
  useLazyGetAddressQuery,
  useUpdateAddressMutation,
  useDeleteAddressMutation,
  useListTicketAgentSessionsQuery,
  useLazyListTicketAgentSessionsQuery,
  useCreateTicketAgentSessionMutation,
  useGetAgentSessionQuery,
  useLazyGetAgentSessionQuery,
  useUpdateAgentSessionMutation,
  useListAgentActivitiesQuery,
  useLazyListAgentActivitiesQuery,
  useCreateAgentActivityMutation,
  useCreateAgentPromptMutation
} = injectedRtkApi
